module.exports = __webpack_public_path__ + "images/emoji/relieved.e41c30fe9f7be0a23366.png";